import { FadeUp } from "@/components/motion/Reveal";
import { company } from "@/data/site";
import { TerminDialog } from "@/components/TerminDialog";

export const CtaBand = () => (
  <section data-testid="cta-section" className="section border-t hairline relative overflow-hidden">
    <div aria-hidden="true" className="absolute -bottom-40 left-[-10%] h-[420px] w-[420px] rounded-full bg-[color:var(--plum)] opacity-[0.16] blur-[150px]" />
    <div className="container-x relative grid lg:grid-cols-12 gap-8 items-center">
      <div className="lg:col-span-7">
        <FadeUp><p className="eyebrow mb-4">Kontakt</p></FadeUp>
        <FadeUp delay={0.05}><h2 className="h-section">Sagen Sie uns, was Ihr Auto braucht.</h2></FadeUp>
        <FadeUp delay={0.1} className="lead mt-5 max-w-lg">Senden Sie uns eine Terminanfrage oder rufen Sie an. Wir melden uns persönlich – eine Anfrage ist noch keine Buchungsbestätigung.</FadeUp>
      </div>
      <FadeUp delay={0.15} className="lg:col-span-5 flex flex-wrap lg:justify-end gap-3">
        <TerminDialog testId="cta-appointment-button" className="btn-violet" />
        <a href={company.phoneHref} data-testid="cta-call-button" className="btn-outline">{company.phone}</a>
      </FadeUp>
    </div>
  </section>
);
